// extracted by mini-css-extract-plugin
module.exports = {"container":"CommentList_container__ME3JP","btn_read_more":"CommentList_btn_read_more__tyEa6"};